import qs from 'query-string';
import { useQuery } from '@cap/ssr-common-utils';
import { useMemo } from 'react';

export { useQuery };

/**
 * 获取url的查询参数值
 * @param key
 * @returns
 */
export const useQueryParams = (key: string): string | null | Array<string | null> => {
  const query = useQuery();
  return query[key] || '';
};

/**
 * 从指定的url获取url的查询参数值
 * @param key
 * @returns
 */
export const useQueryParamsInUrl = (
  url: string,
  key: string,
): string | null | Array<string | null> => {
  const query = useMemo(() => {
    return qs.parse(url?.split('?')[1] || '');
  }, [url]);

  return query[key] || '';
};
